import { useState } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  TextField,
  FormControlLabel,
  FormControl,
  RadioGroup,
  Radio,
  Backdrop,
  makeStyles,
  CircularProgress
} from '@material-ui/core'
import { acceptNonConformity } from '../../api/nonConformityIncidences.service'
import { getInputValue } from '../../common/utils'
import LoadMultipleFiles from '../../components/Resources/LoadMultipleFiles'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}))

const AcceptNonConformity = (params) => {
  const classes = useStyles
  const incidenceCode = params.incidenceCode
  const open = params.open
  const onSave = params.onSave
  const onCancel = params.onCancel

  const [stateForm, setStateForm] = useState({
    comment: '',
    isDestruction: 'true'
  })
  const [resources, setResources] = useState([])
  const [loading, setLoading] = useState(false)

  const handleInputChange = (event) => {
    const value = getInputValue(event.target)
    const name = event.target.name

    setStateForm({
      ...stateForm,
      [name]: value
    })
  }

  const handleAcceptOrder = async () => {
    const params = {
      ...stateForm,
      hncCode: incidenceCode,
      isDestruction: stateForm.isDestruction === 'true' ? true : false,
      attachments: resources
    }
    setLoading(true)
    await acceptNonConformity(params)
      .then(() => {
        onSave()
        onCancel()
      })
      .finally(() => {
        setLoading(false)
      })
  }

  return (
    <div>
      <Dialog open={open}>
        <DialogContent>
          <Typography>
            {`¿Está seguro de que desea aceptar la incidencia de no conformidad ${incidenceCode}?`}
          </Typography>
          <FormControl>
            <RadioGroup
              name="isDestruction"
              row
              value={stateForm.isDestruction}
              onChange={handleInputChange}
            >
              <FormControlLabel value="true" control={<Radio />} label="Destrucción" />
              <FormControlLabel value="false" control={<Radio />} label="Devolución" />
            </RadioGroup>
          </FormControl>
          <TextField
            type="text"
            label="Comentario"
            placeholder="¿Tiene algún comentario? "
            name="comment"
            fullWidth
            variant="outlined"
            multiline
            rows={3}
            value={stateForm.comment}
            disabled={loading}
            onChange={handleInputChange}
          />
          <LoadMultipleFiles canDelete={true} resources={resources} setResources={setResources} />
        </DialogContent>
        <DialogActions>
          <Button disabled={loading} onClick={handleAcceptOrder} autoFocus color="secondary">
            Aceptar
          </Button>
          <Button disabled={loading} onClick={onCancel}>
            Cancelar
          </Button>
        </DialogActions>
        <Backdrop className={classes.backdrop} open={loading} onClick={onCancel}>
          <CircularProgress color="inherit" />
        </Backdrop>
      </Dialog>
    </div>
  )
}

export default AcceptNonConformity
